export const submitFormToServer = async (
    params: object)
: Promise<any> => {
    const data = {
        id: 1,
        domain: 'websiteforge.com',
        wfuserlogin: 'luckyduck',
        wfuserpassword: 'gh&6hd#42',
        type: 'feedbackDataPost',
        data: {
            id: 5557728,
            post: JSON.stringify(params)
        }
    };
    const response = await fetch('https://secure.wf-api.com/core/webservice', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
    }
    const resp = await response.json();
    if (resp['ErrorText']) {
        throw new Error(resp['ErrorText']);
    }
    return resp['Data'];
};